import { React } from "react";
import { useField, ErrorMessage } from "formik";
import { useSelect } from "downshift";

function DropdownSelect(props) {
  const {
    items,
    name,
    onSelectedItemChange,
    required,
    disabled = false,
  } = props;

  const [field, meta, helpers] = useField(name);

  const {
    isOpen,
    selectedItem,
    getToggleButtonProps,
    getLabelProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
  } = useSelect({
    items,
    onSelectedItemChange: ({ selectedItem }) => {
      helpers.setValue(selectedItem.id);
      if (onSelectedItemChange) {
        onSelectedItemChange(selectedItem.id);
      }
    },
  });

  return (
    <div className="containerDropdown">
      <label {...getLabelProps()}>
        Bitte wählen Sie {props.label} {required ? <sup>*</sup> : null}
      </label>
      <button
        className={meta.touched && meta.error ? "error_dropdown" : "dropdown"}
        type="button"
        {...getToggleButtonProps()}
        disabled={disabled}
      >
        {selectedItem ? selectedItem.name : "keine Auswahl"}
        {isOpen ? (
          <div
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL ?? ""
              }/chevron-up.svg)`,
              height: "18px",
              width: "18px",
              backgroundPosition: "center",
            }}
          ></div>
        ) : (
          <div
            style={{
              backgroundImage: `url(${
                process.env.PUBLIC_URL ?? ""
              }/chevron-down.svg)`,
              height: "18px",
              width: "18px",
              backgroundPosition: "center",
            }}
          ></div>
        )}
      </button>
      <div className="select">
        <ul {...getMenuProps()}>
          {isOpen &&
            items.map((item, index) => (
              <li
                style={
                  highlightedIndex === index
                    ? {
                        backgroundColor: "#134094",
                        color: "white",
                        border: "solid 0.5px #134094",
                      }
                    : {}
                }
                key={`${item.id}`}
                {...getItemProps({ item, index })}
              >
                {item.name}
              </li>
            ))}
        </ul>
      </div>
      <ErrorMessage
        name={name}
        component="p"
        className="dropdown_error_message"
      />
    </div>
  );
}
export default DropdownSelect;
